import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { TipoCategoria } from '@tivic-team/manager-ts/dist/mob/enums/concessao/tipo-categoria.enum';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';
import { ConcessionarioPessoaDTO } from 'app/model/dtos/mob/concessionario-pessoa.dto';
import { DocumentoArquivoDTO } from 'app/model/dtos/ptc/documento-arquivo.dto';
import { LocalStorageService } from 'app/services/local-storage.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';
import { ConcessionarioPessoaService } from '../../../../../../services/mob/concessionario-pessoa.service';
import { ResultConcessionarioPessoaBuilder } from './result-concessionario-pessoa.builder';
@Component({
  selector: 'button-salvar-pessoa-fisica',
  templateUrl: './button-salvar.component.html',
  styleUrls: ['./button-salvar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ButtonSalvarComponent implements OnInit {

  formGroup: FormGroup;
  cdConcessao: number;
  usuario: Usuario;

  constructor(
    private _concessionarioPessoaService: ConcessionarioPessoaService,
    private _controlContainer: ControlContainer,
    private _activatedRoute: ActivatedRoute,
    private _dialogFactory: DialogFactory,
    private _router: Router,
    private _localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.usuario = this._localStorage.usuario;
  } 

  ngAfterViewInit() {
    this.cdConcessao = this._activatedRoute.snapshot.params['cdConcessao'];
  }

  public onSubmit() {
    try {
      if(this.formGroup.value.concessao.tpConcessao == ConcessaoTipo.MOTO_TAXI && !this.formGroup.value.cdConcessionarioPessoa) {
        this._dialogFactory
        .confirm("Salvar motorista auxiliar", "Atenção! Para cadastrar um motorista auxiliar, é necessário que o permissionário responsável esteja temporariamente impossibilitado.", "Sim", "Não")
        .subscribe(async (resp: boolean) => {
          if(resp) 
            this.save()
        })
        return;
      }
      this.save();
    }catch (error) {
      this._dialogFactory.snack(error.message, 'OK', DialogFactory.SNACK_ERROR);
    }
  }
  
  async save() {
    try {
      if(this.formGroup.invalid) {
        this.formGroup.markAllAsTouched();
        return this._dialogFactory.snack('Campos obrigatórios inválidos', 'OK', DialogFactory.SNACK_WARNING);
      }
        let concessionarioPessoaDTO: ConcessionarioPessoaDTO = this.formGroup.getRawValue();
        this.formGroup.get("cdUsuarioCadastro").setValue(this.usuario.cdUsuario);
        this._buildConcessionarioPessoa(concessionarioPessoaDTO);
        this._filtrarDocumentos(concessionarioPessoaDTO);
        concessionarioPessoaDTO = await this._concessionarioPessoaService.save(concessionarioPessoaDTO);
        new ResultConcessionarioPessoaBuilder(this._activatedRoute, this._dialogFactory, this._router).build(concessionarioPessoaDTO);  
    }
    catch (error) {
      this._dialogFactory.snack(error.message, 'OK', DialogFactory.SNACK_ERROR);
    }
  }

  private _filtrarDocumentos(concessionario: ConcessionarioPessoaDTO): void {
    if(concessionario.documentoArquivoDTO) {
      concessionario.documentoArquivoDTO = concessionario.documentoArquivoDTO.filter((doc: DocumentoArquivoDTO) => {
        if(doc.blbArquivo) {
          doc.tpCategoria = TipoCategoria.MOTORISTA_AUXILIAR
          return true;
        }
        return false;
      });    
    }
  }

  private _buildConcessionarioPessoa(concessionarioPessoaDTO: ConcessionarioPessoaDTO ){
    concessionarioPessoaDTO.cdPessoa = this.formGroup.get("pessoaFisica").get("pessoa").get("cdPessoa").value;
    concessionarioPessoaDTO.cdConcessionario = this.formGroup.get("concessao").get("cdConcessionario").value;
    concessionarioPessoaDTO.cdConcessao = this.formGroup.get("concessao").get("cdConcessao").value;
  }
}